<template>
  <v-content grid-list-md class="white-background">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Inspector Login
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                Inspectors Login Here!
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>
    <v-container class="white-background">
      <v-layout
        row
        wrap
        align-center
        justify-center
        class="white-background pb-5"
      >
        <v-flex xs12 sm8 lg6 class="pa-5 ma-5 pb-5">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Login to the Strata Inspection Portal as an Inspector</span
              >
            </v-card-title>
            <v-spacer />

            <v-card-text>
              <v-layout row justify-center align-center v-if="alert.loading">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-layout>

              <v-form v-else ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-text-field
                    v-model="credentials.username"
                    :counter="70"
                    label="username"
                    :rules="rules.username"
                    maxlength="70"
                    required
                  ></v-text-field>

                  <v-text-field
                    type="password"
                    v-model="credentials.password"
                    :counter="50"
                    label="password"
                    :rules="rules.password"
                    maxlength="50"
                    required
                  ></v-text-field>
                </v-container>
                <v-btn
                  class="blue white--text"
                  :disabled="!valid"
                  @click="login"
                  >Login</v-btn
                >
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Snackbar -->
    <v-snackbar v-model="alert.message" top left :timeout="timeout">
      {{text}}
    </v-snackbar>
    <Footer :absolute="false"></Footer>
  </v-content>
</template>

<script>
import axios from "axios";
//import swal from 'sweetalert2';
import { router } from "../router";
import { config } from "../config/config";
import { users } from "../helpers";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "InspectorLogin",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    portalUrl: config.insAuthUrl,
    notification: false,
    timeout: 6000,
    text: "Can't find username and password.",
    credentials: {},
    valid: true,
    loading: false,
    rules: {
      username: [
        v => !!v || "Username is required",
        v =>
          (v && v.length > 3) ||
          "A username must be more than 3 characters long",
        v =>
          /^[a-zA-Z0-9_@.-]+$/.test(v) ||
          "A username can only contain letters and digits and special characters"
      ],
      password: [
        v => !!v || "Password is required",
        v =>
          (v && v.length > 4) || "The password must be longer than 7 characters"
      ]
    }
  }),
  computed: {
      alert() {
          return this.$store.state.alert
      }
  },
  methods: {
    login() {
      // checking if the input is valid
      if (this.$refs.form.validate()) {
        const { username, password } = this.credentials;

        if (username && password) {
          this.$store.dispatch("authentication/login", {
            username: username,
            password: password,
            userType: users.ins
          });
        }
      }
    },
    gotoHome() {
      router.push("/");
    },
    gotoLogin() {
      router.push("/login");
    },
    gotoHelp() {
      router.push("/faq");
    }
  }
};
</script>
